import React from "react";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section
      id="top"
      className="relative pt-32 pb-12 md:pt-40 md:pb-20 satin-bg"
      data-testid="hero-section"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
        >
          <h1
            className="font-serif text-5xl md:text-7xl lg:text-[88px] font-light text-[#1A1612] leading-[1.05] tracking-tight mb-8"
            data-testid="hero-title"
          >
            Alege experiența{" "}
            <span className="italic">ELENUIT</span>
          </h1>
          <div className="sep-line max-w-xs mx-auto">
            <span className="diamond" />
          </div>
          <p className="text-base md:text-lg text-[#6E665A] font-light leading-relaxed max-w-xl mx-auto mt-6">
            Vinuri create pentru seri fără grabă și momente care rămân.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
